module.exports = __webpack_public_path__ + "static/media/arrow_forward.a08038d8.svg";